<div class="cetegoriesPanel">
  <p-carousel
    [value]="products"
    styleClass="custom-carousel"
    [numVisible]="3"
    [numScroll]="1"
    [circular]="true"
    [responsiveOptions]="responsiveOptionsActivity"
    [ngClass]="language"
  >
    <ng-template let-product pTemplate="item">
      <div class="product-item" (click)="getItems(product)">
        <div class="product-item-content">
          <div
            class="image"
            [style.background-image]="
              product.image ? 'url(' + product.image + ')' : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
            "
          >
            <img [src]="" [alt]="product.name" class="product-image" stlye="width:100%" />
          </div>
          <div
            (click)="getItems(product)"
            class="title"
            [class.ru-style]="language === 'RU'"
            style="top: 42%; left: 35%; background: none; color: #fff; line-height: 14px; font-weight: 700"
          >
            <!-- <h4 class="p-mb-1">{{ product.name | translate }}</h4> -->
            <div class="first-word inter-font" style="font-size: 32px">
              {{ (product.name | translate).split(' ')[0] }}
            </div>
            <div class="other-words cavet-font" style="font-size: 48px; margin-top: 14px; margin-left: 43px">
              {{ (product.name | translate).split(' ').slice(1).join(' ') }}
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </p-carousel>
</div>

<div *ngIf="filteredData && filteredData.length > 0">
  <div class="whatDoSection" *ngFor="let item of filteredData">
    <h2 translate class="thingsToDo" style="padding-left: 1.2rem" *ngIf="item.name">
      <span class="inter-font">{{ (item.name | translate)?.split(' ')[0] }}</span>
      <span class="cavet-font" style="margin-left: 10px">{{
        (item.name | translate)?.split(' ').slice(1).join(' ')
      }}</span>
    </h2>

    <div class="card catsection" style="margin-top: 30px" *ngIf="item.child && item.child.length > 0">
      <p-tabView styleClass="tabview-custom">
        <!-- Added trackBy -->
        <p-tabPanel *ngFor="let childitem of item.child; trackBy: trackByChildItemId">
          <ng-template pTemplate="header">
            <div
              (click)="getChildItems(childitem)"
              (keyup.enter)="getChildItems(childitem)"
              tabindex="0"
              role="tab"
              [attr.aria-selected]="isSelected(childitem)"
              class="tab-header-content"
            >
              <i
                *ngIf="childitem.category === DealsOffersCategoryIdentifier; else defaultIcon"
                class="deals-icon"
                [ngClass]="{ 'icon-black': !isSelected(childitem), 'icon-white': isSelected(childitem) }"
                aria-hidden="true"
              >
              </i>
              <ng-template #defaultIcon>
                <i class="{{ childitem.iconUrl }}" aria-hidden="true"></i>
              </ng-template>
              <span class="tab-header-text" style="font-size: 16px">{{ childitem.name | translate }}</span>
            </div>
          </ng-template>

          <ng-container *ngIf="activeChildCategoryKey === generateCategoryKey(childitem)">
            <div class="carousel-grid slider-arrow">
              <div class="carousel-items" *ngIf="searchCategories && searchCategories.length > 0; else noItemsMessage">
                <p-carousel
                  [value]="searchCategories"
                  styleClass="custom-carousel inner-item-carousel"
                  [numVisible]="4"
                  [numScroll]="1"
                  [circular]="false"
                  [responsiveOptions]="responsiveOptions"
                  [ngClass]="language"
                  (onPage)="onSubTabCarouselPageChange($event)"
                >
                  <ng-template let-product pTemplate="item">
                    <a
                      *ngIf="product && product.productId"
                      target="_blank"
                      class="product-item inner-product-item"
                      [href]="'/listingdetails/' + product.productId"
                      [attr.aria-label]="product.productName"
                    >
                      <div class="product-item-content" style="margin: 0 10px">
                        <img
                          *ngIf="product.productImage"
                          class="product-image inner-product-image"
                          [src]="product.productImage"
                          [alt]="product.productName || 'Product Image'"
                          style="width: 100%; display: block; aspect-ratio: 460 / 600"
                          loading="lazy"
                          onError="this.onerror=null; this.src='/assets/images/NoImage.jpg';"
                        />
                        <img
                          *ngIf="!product.productImage"
                          class="product-image inner-product-image placeholder-image"
                          src="/assets/images/NoImage.jpg"
                          alt="Placeholder Image"
                          style="width: 100%; display: block; aspect-ratio: 460 / 600"
                        />
                        <div class="category-title">
                          <h1 style="font-size: 18px; font-weight: 500; line-height: 1.2">
                            {{
                              product.productName.length > 30
                                ? (product.productName | slice: 0:30) + '...'
                                : product.productName
                            }}
                          </h1>
                          <small *ngIf="product.addresses && product.addresses.length && product.addresses[0].island">
                            <i class="icon-location"></i>{{ product.addresses[0].islandArea }}
                            <span *ngIf="product.addresses[0].islandArea && product.addresses[0].island">,&nbsp;</span>
                            {{ product.addresses[0].island }}
                          </small>
                        </div>
                        <div class="category-icon" *ngIf="activityIcon">
                          <i class="{{ activityIcon }}" aria-hidden="true"></i>
                        </div>
                      </div>
                    </a>
                    <div
                      *ngIf="!product || !product.productId"
                      class="product-item inner-product-item is-placeholder"
                      aria-hidden="true"
                    ></div>
                  </ng-template>
                </p-carousel>
              </div>

              <div class="viewall-btn">
                <a
                  [href]="getUrlForCategory(childitem.name)"
                  class="pointer viewall-link"
                  [attr.aria-label]="('View All' | translate) + ' ' + (childitem.name | translate)"
                  (click)="thingTODOPageSelection(childitem.name)"
                  >{{ 'View All' | translate }}<i class="pi pi-angle-right" aria-hidden="true"></i>
                </a>
              </div>

              <!-- Message shown only when there are no items and not currently loading -->
              <ng-template #noItemsMessage>
                <div class="feedback-message" style="text-align: center; padding: 30px; min-height: 150px">
                  <!-- Removed loading spinner check -->
                  <!-- Show "no items" message if not loading (important check!) AND array is empty -->
                  <p
                    *ngIf="
                      !getCarouselState(activeChildCategoryKey)?.isLoadingMore &&
                      (!searchCategories || searchCategories.length === 0)
                    "
                  >
                    {{ 'No items found for this category.' | translate }}
                  </p>
                  <!-- Optionally add a message shown *while* loading if needed, without spinner -->
                  <p *ngIf="getCarouselState(activeChildCategoryKey)?.isLoadingMore">
                    <!-- {{ 'Loading...' | translate }} -->
                  </p>
                </div>
              </ng-template>
            </div>
          </ng-container>
        </p-tabPanel>
      </p-tabView>
    </div>
    <div *ngIf="item.child && item.child.length === 0" style="text-align: center; padding: 20px">
      <p>{{ 'No sub-categories available.' | translate }}</p>
    </div>
  </div>
</div>

<!-- Removed global loader -->
<!--
<div class="np-loader global-loader" *ngIf="loaderService.isLoading$ | async">
  <p-progressSpinner strokeWidth="5"></p-progressSpinner>
</div>
-->
